import {
  FETCH_START,
  FETCH_END,
  TERRITORY_FORMAT_SUCCESS,
  TERRITORY_FORMAT_BY_ID_SUCCESS,
  TERRITORY_FORMAT_FIELDS_SUCCESS,
  TERRITORY_UPLOAD_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { toast } from 'react-toastify';
import { history } from '../../../components/Helpers';
import secureLocalStorage from 'react-secure-storage';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};
// territory format
export const getTerritoryFormatData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getTerritoryFormatDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getTerritoryFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};
const getTerritoryFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('upload-format?app-functionality=TerritoryMasterFormats', {
    headers: headers,
  });
  return result;
};
export const getTerritoryFormatDataSuccess = (data) => {
  return {
    type: TERRITORY_FORMAT_SUCCESS,
    data,
  };
};
export const getTerritoryFormatDataById = (id) => {
  return (dispatch) => {
    getTerritoryFormatDataByIdApi(id)
      .then((response) => {
        dispatch(getTerritoryFormatDataByIdSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};
const getTerritoryFormatDataByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format/' + id + '?app-functionality=TerritoryMasterFormats',
    { headers: headers },
  );
  return result;
};
export const getTerritoryFormatDataByIdSuccess = (data) => {
  return {
    type: TERRITORY_FORMAT_BY_ID_SUCCESS,
    data,
  };
};
export const getTerritoryFormatFields = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getTerritoryFormatFieldsApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getTerritoryFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};
const getTerritoryFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=TerritoryMasterFormats',
    { headers: headers },
  );
  return result;
};
export const getTerritoryFormatFieldsSuccess = (data) => {
  return {
    type: TERRITORY_FORMAT_FIELDS_SUCCESS,
    data,
  };
};
export const updateTerritoryFormatData = (id, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateTerritoryFormatDataApi(id, data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201) {
          toast.success(response.data.response);
          history.push('/territory/territory-excel-upload');
        } else {
          //toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};
const updateTerritoryFormatDataApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' + id + '?app-functionality=TerritoryMasterFormats',
    data,
    { headers: headers },
  );
  return result;
};
export const addTerritoryFormatData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addTerritoryFormatDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        //dispatch(getTerritoryFormatData())
        toast.success(response.data.response);
        history.push('/territory/territory-excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};
const addTerritoryFormatDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'upload-format?app-functionality=TerritoryMasterFormats',
    data,
    { headers: headers },
  );
  return result;
};
export const deleteTerritoryFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteTerritoryFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201) {
          toast.success(response.data.response);
          dispatch(getTerritoryFormatData());
          // window.location.reload();
        } else {
          //toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};
const deleteTerritoryFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};
// //upload File
export const uploadTerritoryFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadTerritoryFileApi(id, file)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadTerritoryFileSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.error_list == null
          ) {
            toast.success(response.data.response.success_msg);
          }
        } else {
          dispatch(fetchEnd());
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadTerritoryFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('territory-upload?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};
export const uploadTerritoryFileSuccess = (data) => {
  return {
    type: TERRITORY_UPLOAD_SUCCESS,
    data,
  };
};
